import RateCard from "./RateCard";

export default RateCard;
